import { US_STATES } from "../data/usStatesAndCities";

const CODE_TO_NAME = {};
const NAME_TO_CODE = {};
US_STATES.forEach(({ name, abbreviation }) => {
  CODE_TO_NAME[abbreviation] = name;
  NAME_TO_CODE[name.toLowerCase()] = abbreviation;
});

/** Given a state code or full name, return the full name. */
export const resolveStateName = (value) => {
  if (!value) return "";
  const upper = value.toUpperCase();
  if (CODE_TO_NAME[upper]) return CODE_TO_NAME[upper];
  const lower = value.toLowerCase();
  if (NAME_TO_CODE[lower]) return value;
  return value;
};

/** Given a state code or full name, return the 2-letter code. */
export const resolveStateCode = (value) => {
  if (!value) return "";
  const upper = value.toUpperCase();
  if (CODE_TO_NAME[upper]) return upper;
  const lower = value.toLowerCase();
  if (NAME_TO_CODE[lower]) return NAME_TO_CODE[lower];
  return value;
};

/** "California (CA)" display format. */
export const formatStateDisplay = (value) => {
  if (!value) return "N/A";
  const code = resolveStateCode(value);
  const name = resolveStateName(value);
  if (code !== name) return `${name} (${code})`;
  return value;
};
